import { DropdownItem, DropdownSelectionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutAddNewProfileDialog } from "./autogen/AutogenLayoutAddNewProfileDialog";

export class AddNewProfileDialog extends AutogenLayoutAddNewProfileDialog {
    // Override any methods or properties here
    onLoad(): void | Promise<void> {
        this.textboxTransactionType.items = [
            new DropdownItem("T", "Tender"),
            new DropdownItem("I", "Invoice"),
            new DropdownItem("G", "Generic"),
            new DropdownItem("A", "Remittance Advice"),
            new DropdownItem("S", "Shipment Status")
        ];
        this.textboxDirection.items = [
            new DropdownItem("I", "Inbound"),
            new DropdownItem("O", "Outbound")
        ];
        this.textboxTransactionType.required = true;
        this.textboxDirection.required = true;
        this.textboxTemplate.required = true;
        this.textboxDirection.enabled = false;
        this.textboxTemplate.enabled = false;
    }

    transactionTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.hasSelection()) {
            this.textboxDirection.enabled = true;
            if (this.textboxTransactionType.selectedItem?.value === "G" || this.textboxTransactionType.selectedItem?.value === "A") {
                this.textboxDirection.items = [
                    new DropdownItem("I", "Inbound")
                ];
                this.textboxDirection.selectedItem = this.textboxDirection.items[0];
            } else {
                this.textboxDirection.items = [
                    new DropdownItem("I", "Inbound"),
                    new DropdownItem("O", "Outbound")
                ];
                this.textboxDirection.selectedItem = null;
            }
        } else {
            this.textboxDirection.selectedItem = null;
            this.textboxDirection.enabled = false;
            this.textboxDirection.required = true;
            this.textboxTemplate.selectedItem = null;
            this.textboxTemplate.enabled = false;
            this.textboxTemplate.required = true;
        }
    }

    directionAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.hasSelection()) {
            if (this.textboxTransactionType.selectedItem?.value === "G" && this.textboxDirection.selectedItem?.value === "I") {
                this.textboxTemplate.required = false;
            } else {
                this.textboxTemplate.required = true;
            }
            this.textboxTemplate.enabled = true;
            this.textboxTemplate.clear();
        } else {
            this.textboxTemplate.selectedItem = null;
            this.textboxTemplate.enabled = false;
            this.textboxTemplate.required = true;
        }
    }

    templateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        if (this.textboxTransactionType.selectedItem?.value !== "G") {
            event.filter.direction = this.textboxDirection.selectedItem?.value;
            event.filter.transaction_type = this.textboxTransactionType.selectedItem?.value;
        } else {
            event.filter.direction = "I";
            event.filter.transaction_type_input_generic = true;
        }

    }
}